import FilesDocumentation from './FilesDocumentation'

export default FilesDocumentation
